module.exports = __webpack_public_path__ + "img/125.7.dff88045.png";